import script from "./gameList.vue?vue&type=script&setup=true&lang=js"
export * from "./gameList.vue?vue&type=script&setup=true&lang=js"

import "./gameList.vue?vue&type=style&index=0&id=04ed3a46&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04ed3a46"]])

export default __exports__